module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Archive-42529b511819150347aa3e590386faa2.svg";